import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    mathFormulaWaterQuality: function mathFormulaWaterQuality(itemType, currentValue) {
      return request({
        url: "/aimodel/mathFormula/waterQuality/".concat(itemType, "/").concat(currentValue),
        method: 'post'
      });
    },
    mathFormulaWaterQualitys: function mathFormulaWaterQualitys(data) {
      return request({
        url: "/aimodel/mathFormula/waterQualitys",
        method: 'post',
        data: data
      });
    }
  };
});